import { Component } from '@angular/core';

@Component({
    template: `<app-audio-video-modal />`,
    standalone: false
})
export class AudioVideoModalContainerComponent {
  static identifier = 'AudioVideoModalContainerComponent';
}
